import { CouponCreateType, CouponCustomerInfoType } from "interfaces";
import { REGEX_VALID_EMAIL } from "utills/constants";
import { z } from "zod";

export const EditPromotionCouponSchema = () => {
  return z
    .object({
      max_times_used: z
        .number({
          invalid_type_error: "Please input a number",
        })
        .int()
        .min(1, "Max times used must be at least 1"),

      is_active: z.boolean(),
      rule_id: z.number({
        invalid_type_error: "Invalid type",
        required_error: "This field is required",
      }),
      short_desc_vi: z.string().optional(),
      short_desc_en: z.string().optional(),
      displayed_on_actiup: z.boolean(),
      displayed_on_whitelabel: z.boolean(),

      // Customer info type
      customer_info_type: z
        .enum([CouponCustomerInfoType.CODE, CouponCustomerInfoType.EMAIL])
        .nullable()
        .optional(),
      customer_info_value: z.string().nullable().optional(),
    })
    .superRefine((data, ctx) => {
      if (data.customer_info_type && !data.customer_info_value) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "This field is required",
          path: ["customer_info_value"],
        });
      }
      if (
        data.customer_info_type === CouponCustomerInfoType.EMAIL &&
        data.customer_info_value &&
        !REGEX_VALID_EMAIL.test(data.customer_info_value)
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Invalid email format",
          path: ["customer_info_value"],
        });
      }

      // Validate customer code length
      if (
        data.customer_info_type === CouponCustomerInfoType.CODE &&
        data.customer_info_value &&
        data.customer_info_value.length > 32
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Customer code must be less than 32 characters",
          path: ["customer_info_value"],
        });
      }
    });
};
